import { Component, OnInit, TemplateRef } from '@angular/core';
import { RestaurantServiceService } from '../restaurant-service.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
// import * as mapboxgl from 'mapbox-gl';

@Component({
  selector: 'app-restaurents-info',
  templateUrl: './restaurents-info.component.html',
  styleUrls: ['./restaurents-info.component.scss']
})
export class RestaurentsInfoComponent implements OnInit {


  constructor(
    private modalService: BsModalService,
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private router: Router,
    private restaurantService: RestaurantServiceService,
  ) {
    this.id = this.route.snapshot.params['id'];

   }
  //  map: mapboxgl.Map;

  uploadForm: FormGroup;
  myForm: FormGroup;
  modalRef: BsModalRef;
  imageList: any = [];
  id: number;
  service: any = [];
  listOfOrders: any = [];
  listOfFeedback: any = [];
  p1= 1;
  imagesUrl: any;
  imageUrl: any;
  hideinfo = false;
  hideorder = true;
  hidehistory = true;
  hidephoto = true;
  hidesetting = true;
  show = false;
  customerfeedback = true;
  restauranDetail: any = [];
  message: string;
  settingUpdate = false;

  style = 'mapbox://styles/mapbox/streets-v11';
  lat = 37.75;
  lng = -122.41;

  ngOnInit() {

    this.restaurantInf();
    this.EditRestaurant();
    this.getImageOfRestaurant();
    this.getOrdersById();
    this.getFeedback();
    this.uploadForm = this.formBuilder.group({
      file: ['']
    });
    this.myForm = this.formBuilder.group({
      radio: ''
    });
  //   mapboxgl.accessToken = 'pk.eyJ1IjoiaGFtemFqYXZhaWQiLCJhIjoiY2s1ZHJoNXd1MXVoMDNqbXVtdW95djFyNiJ9.wuH-3fSlUHdduK3gwhhfRg';

  //   this.map = new mapboxgl.Map({
  //     container: 'map',
  //     style: this.style,
  //     zoom: 13,
  //     center: [74 , 34]
  // });
  // this.map.addControl(new mapboxgl.NavigationControl());

  }
  // getMarkers() {
  //     const geoJson = [{
  //       'type': 'Feature',
  //       'geometry': {
  //         'type': 'Point',
  //         'coordinates': ['80.20929129999999', '13.0569951']
  //       },
  //       'properties': {
  //         'message': 'Chennai'
  //       }
  //     }, {
  //       'type': 'Feature',
  //       'geometry': {
  //         'type': 'Point',
  //         'coordinates': ['77.350048', '12.953847' ]
  //       },
  //       'properties': {
  //         'message': 'bangulare'
  //       }
  //     }];
  //     return geoJson;
  //   }

  EditRestaurant() {
    this.restaurantService.getRestaurantbyId(this.id).subscribe(Response => {
      this.restauranDetail = Response.Restaurant;
    });
  }

  restaurantInf() {
    this.restaurantService.getRestaurantbyId(this.id)
      .subscribe(data => {
        this.service = data.Restaurant;
        this.imagesUrl = data['RestaurantImagesURL'];
        this.imageUrl = this.imagesUrl[0];
      });
  }

  getOrdersById() {
    debugger;
    this.restaurantService.GETAllOrders(this.id).subscribe(Response => {
      this.listOfOrders = Response;
       console.log('newwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwww', this.listOfOrders);
    });
  }
  getFeedback() {
    debugger;
    this.restaurantService.GETAllFeedBack(this.id).subscribe(Response => {
      this.listOfFeedback = Response;
    });
  }
  handleFileInput(event) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.show = true;
      this.uploadForm.get('file').setValue(file);

    }
  }
  settingupdate() {
    if (this.settingUpdate) {
      return this.settingUpdate = false;
    } else {
     return this.settingUpdate = true;
    }
  }


  onSubmit() {
    const formData = new FormData();
    formData.append('file', this.uploadForm.get('file').value);

    formData.append('RestaurantId', this.id.toString());
    this.restaurantService.MediaUpload(formData).subscribe((Data: any) => {
      if (!Data.HasErrors) {
        // this.toastr.success('Image Uploaded...');
        this.show = false;
      }

      this.restaurantInf();
    }, error => {
      // console.log('error::::::', error);
    }
    );
  }

  onSubmitPhoto() {
    const formData = new FormData();
    formData.append('file', this.uploadForm.get('file').value);
    formData.append('RestaurantId', this.id.toString());
    this.restaurantService.MediaUploadofRestaurant(formData).subscribe((Data: any) => {
    if (!Data.HasErrors) {
      this.toastr.success('Image Uploaded...');
      this.show = false;
    }
      this.getImageOfRestaurant();
    }, error => {
      this.toastr.error(error.error.Message);
    });
  }

  getImageOfRestaurant() {
    this.restaurantService.getRestautrantImgbyId(this.id).subscribe(Response => {
      this.imageList = Response;
    });
  }

  confirm(id): void {
    this.message = 'Confirmed!';
    this.restaurantService.DeleteImage(id).subscribe(Response => {
      this.getImageOfRestaurant();
    });
    this.modalRef.hide();
  }

  decline(): void {
    this.message = 'Declined!';
    this.modalRef.hide();
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, {class: 'modal-sm'});
 }



 updateAddress() {
  this.restaurantService.UpdateResturant(this.restauranDetail).subscribe((Data: any) => {
    if (!Data.id) {
    this.toastr.success('Resturant updated');
    this.router.navigateByUrl('/restaurantsinfo/' + this.id);
    }

  }, error => {
    this.toastr.success(error.error.Message);
  });
   this.modalRef.hide();
 }
 gotoMenu() {
  this.router.navigateByUrl('/menu/' + this.id);
 }

  gotoRestaurantInfo() {
     this.hideinfo = false;
     this.hidehistory = true;
     this.hideorder = true;
     this.hidephoto = true;
     this.hidesetting = true ;
     this.customerfeedback = true;
  }

  gotoOrder() {
    this.hideinfo = true;
    this.hidehistory = true;
    this.hideorder = false;
    this.hidephoto = true;
    this.hidesetting = true ;
    this.customerfeedback = true;
  }

  gotoHistory() {
    this.hideinfo = true;
    this.hidehistory = false;
    this.hideorder = true;
    this.hidephoto = true;
    this.hidesetting = true ;
    this.customerfeedback = true;

  }

  gotoPhoto() {
    this.hideinfo = true;
    this.hidehistory = true;
    this.hideorder = true;
    this.hidephoto = false;
    this.hidesetting = true ;
    this.customerfeedback = true;

  }
  gotoSetting() {
    this.hideinfo = true;
    this.hidehistory = true;
    this.hideorder = true;
    this.hidephoto = true;
    this.hidesetting = false ;
    this.customerfeedback = true;

  }
  gotoCustomerFeedBack() {
    this.hideinfo = true;
    this.hidehistory = true;
    this.hideorder = true;
    this.hidephoto = true;
    this.hidesetting = true ;
    this.customerfeedback = false;
  }

  uploadFileInput(event, cityid) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.uploadForm.get('file').setValue(file);
      const formData = new FormData();
      formData.append('file', this.uploadForm.get('file').value);
      formData.append('RestaurantId', cityid.toString());
      this.restaurantService.MediaUpload(formData).subscribe((Data: any) => {
        this.toastr.success('Image Update');
        this.restaurantInf();
      });
    }
  }

  uploadRestaurantImage(event, resId) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.uploadForm.get('file').setValue(file);
      const formData = new FormData();
      formData.append('file', this.uploadForm.get('file').value);
      formData.append('RestaurantId', resId.toString());
      this.restaurantService.RestaurantImageUpload(formData).subscribe((Data: any) => {
        this.toastr.success('Image Update');
        this.restaurantInf();
      });
    }
  }

}
